import Vue from "vue"
import {decamelCase} from "@/utility/data/strings"

Vue.filter("decamelCase", (value: string | null) => {
	if (!value) return ""
	return decamelCase(value.toString())
})
